import React from "react";
import { SECONDARY } from "./Fields.jsx";

export function consolidationVersionChanged(previous, next) {
  return previous.version !== next.version || previous.source_version !== next.source_version
    || previous.day_version !== next.day_version
    || previous.status !== next.status || JSON.stringify(previous.shared_versions) !== JSON.stringify(next.shared_versions);
}

// subject : « Ce relevé » ou « Ce préchargement ». La reprise efface la saisie : l'avis le dit.
export default function ConcurrentChangeNotice({ visible, onReset, subject = "Ce relevé" }) {
  if (!visible) return null;
  return <div role="alert" className="grid gap-2 rounded-[4px] border border-amber-200 bg-amber-50 p-2 text-xs text-amber-900">
    <p>{subject} a changé depuis votre saisie. Vos modifications non sauvegardées ne peuvent plus être enregistrées : « Reprendre les données enregistrées » les efface et affiche la version enregistrée.</p>
    <button type="button" className={`${SECONDARY} justify-self-start`} onClick={onReset}>Reprendre les données enregistrées</button>
  </div>;
}
